/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetCampaignLaunchReadinessQueryResponse,
  GetCampaignLaunchReadinessPathParams,
  GetCampaignLaunchReadiness404,
} from '../types/GetCampaignLaunchReadiness'

function getGetCampaignLaunchReadinessUrl({
  campaign_id,
}: {
  campaign_id: GetCampaignLaunchReadinessPathParams['campaign_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/emailbison/campaigns/${campaign_id}/launch-readiness/` as const,
  }
  return res
}

/**
 * @description Validate launch readiness using fresh EmailBison API state.
 * Endpoint:
 * - GET /api/emailbison/campaigns/<campaign_id>/launch-readiness/
 * @summary Get campaign launch readiness
 * {@link /api/v1/emailbison/campaigns/:campaign_id/launch-readiness/}
 */
export async function getCampaignLaunchReadiness(
  {
    campaign_id,
  }: { campaign_id: GetCampaignLaunchReadinessPathParams['campaign_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetCampaignLaunchReadinessQueryResponse,
    ResponseErrorConfig<GetCampaignLaunchReadiness404>,
    unknown
  >({
    method: 'GET',
    url: getGetCampaignLaunchReadinessUrl({ campaign_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
